// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fNvN","fullView":"styles_fullView__1aCl9"};